import $ from "jquery";
export const toggleMultipleCheckboxes = {
    init: () => {
        toggleMultipleCheckboxes.enableGlobal();
        $("[data-multiple-check]").on("change", function () {
            const $thisElement = $(this);
            const target = $thisElement.data("multiple-check-shared");
            const dataTarget = `[data-multiple-check-shared='${target}']`;
            $(dataTarget).prop("checked", $thisElement.is(":checked"));
        });
    },
    enableGlobal: () => {
        if (!window["toggleMultipleCheckboxes"]) {
            window["toggleMultipleCheckboxes"] = toggleMultipleCheckboxes;
        }
    },
};
